import React, { useCallback, useContext, useEffect, useMemo } from "react";
import { HotjarService } from "@ipru-common/libs/Hotjar/HotjarService";
import { useGlobalContext } from "./GlobalContext";
import useIpsAppApi from "@ipru-common/libs/IpsAppForm/useIpsAppApi";
import { getCurrentProductFromMeta } from "@ipru-common/utils/CommonFunctions";
import { SPOUSE_COVER } from "@ipru-common/constants/SiteConstants";
import useSpouseAppApi from "@ipru-common/libs/IpsAppForm/useSpouseAppApi";
import { HotJarContext as SharedHotJarContext } from "shared-library";

// const SharedHotJarContext = createContext();

export const HotJarProvider = ({ children }) => {
  const {
    global: {
      callDropOff,
      appFormData,
      [SPOUSE_COVER]: { appFormData: spouseAppFormData },
    },
    spouseCoverIncluded,
  } = useGlobalContext();
  const { dropOff } = useIpsAppApi();
  const { dropOff: spouseDropOff } = useSpouseAppApi();

  const pushEvent = useCallback((event) => {
    HotjarService.pushEvent({
      event,
      productCode: getCurrentProductFromMeta(),
    });
  }, []);

  const contextValue = useMemo(() => {
    return { pushEvent };
  }, [pushEvent]);

  useEffect(() => {
    if (callDropOff) {
      if (!appFormData.generatingAppNumber) {
        dropOff();
      }

      if (spouseCoverIncluded && !spouseAppFormData.generatingAppNumber) {
        spouseDropOff();
      }
    }
  }, [callDropOff]);

  return <SharedHotJarContext.Provider value={contextValue}>{children}</SharedHotJarContext.Provider>;
};

export const useHotJar = () => {
  const context = useContext(SharedHotJarContext);
  if (!context) {
    throw new Error("useHotJarContext must be used within a HotJarProvider");
  }
  return context.pushEvent;
};
